import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { 
  FiTwitter, 
  FiInstagram, 
  FiFacebook, 
  FiLinkedin, 
  FiGithub,
  FiMail,
  FiPhone,
  FiMapPin,
  FiArrowUp
} from 'react-icons/fi';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const footerLinks = {
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'How It Works', path: '/#how-it-works' }
    ],
    services: [
      { name: 'Buy Accounts', path: '/accounts' },
      { name: 'Social Boosting', path: '/social-boost' },
      { name: 'Virtual Numbers', path: '/virtual-numbers' }
    ],
    support: [
      { name: 'Help Center', path: 'https://t.me/Nitrologs9' },
      { name: 'Community', path: 'https://t.me/Nitrologs9' },
      // { name: 'Contact Us', path: '/contact' },
    ],
    legal: [
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Terms of Service', path: '/terms' },
    ],
  };

  const socialLinks = [
    { icon: FiTwitter, href: 'https://twitter.com', label: 'Twitter', color: 'hover:text-blue-400' },
    { icon: FiInstagram, href: 'https://instagram.com', label: 'Instagram', color: 'hover:text-pink-500' },
    { icon: FiFacebook, href: 'https://facebook.com', label: 'Facebook', color: 'hover:text-blue-600' },
  ];

  const contactInfo = [
    { icon: FiMail, text: 'nitrologs9@gmail.com', href: 'mailto:nitrologs9@gmail.com' },
    { icon: FiPhone, text: '+234 814 056 5867', href: 'tel:+2348140565867' }
  ];

  return (
    <footer className="relative bg-[#0B1120] border-t border-blue-500/20 w-full">
      {/* Floating Shapes */}
      {/* <div className="absolute w-64 h-64 bg-blue-500/5 rounded-full blur-3xl top-0 left-0 -translate-x-1/2 -translate-y-1/2" /> */}
      {/* <div className="absolute w-96 h-96 bg-cyan-500/5 rounded-full blur-3xl bottom-0 right-0 translate-x-1/2 translate-y-1/2" /> */}

      {/* Scroll to Top Button */}
      <motion.button
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1 }}
        onClick={scrollToTop}
        className="fixed bottom-24 right-6 z-40 w-12 h-12 bg-linear-to-r from-blue-600 to-cyan-600 text-white rounded-xl shadow-lg shadow-blue-500/25 hover:shadow-xl hover:shadow-blue-500/30 transition-all duration-300 z-50 flex items-center justify-center group"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <FiArrowUp className="w-5 h-5 group-hover:-translate-y-1 transition-transform" />
      </motion.button>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Main Footer */}
        <div className="py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-6">
              <div className="w-[100px] flex items-center justify-center">
                <img src="/nitrologs.png" alt="Logo" className="w-full text-white" />
              </div>
              {/* <span className="text-2xl font-display font-bold">
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
                  Nitro
                </span>
                <span className="text-white">Logs</span>
              </span> */}
            </Link>
            <p className="text-gray-400 mb-6 leading-relaxed">
              Your premier destination for verified social media accounts, professional boosting services, and virtual numbers.
            </p>
            <div className="flex space-x-3">
              {socialLinks.map((social) => (
                <motion.a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.1, y: -2 }}
                  className={`w-10 h-10 rounded-xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center text-gray-400 ${social.color} transition-all duration-300`}
                  aria-label={social.label}
                >
                  <social.icon className="w-5 h-5" />
                </motion.a>
              ))}
            </div>
          </div>

          {/* Links Columns */}
          <div>
            <h3 className="text-white font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-blue-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-blue-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Support</h3>
            <ul className="space-y-2">
              {footerLinks.support.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-blue-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-blue-400 transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Contact Info Bar */}
        <div className="py-4 border-t border-blue-500/20">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-6">
              {contactInfo.map((item, index) => (
                <a
                  key={index}
                  href={item.href}
                  className="flex items-center space-x-2 text-gray-400 hover:text-blue-400 transition-colors"
                >
                  <item.icon className="w-4 h-4" />
                  <span>{item.text}</span>
                </a>
              ))}
            </div>
            <div className="text-gray-500">
              © {currentYear} Nitro Logs. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};